import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarkdownArticle, getContentBySlug } from "~/components/content";
import { Shell } from "~/components/site-shell";
import { breadcrumbs, jsonLd, pageUrl, seoHead } from "~/config/seo";
export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const item = getContentBySlug("blog", params.slug);
    if (!item) throw notFound();
    return item;
  },
  head: ({ loaderData, params }) => ({
    ...seoHead({
      title: `${loaderData?.title ?? "Journal"} | HostRight`,
      description: loaderData?.description ?? "",
      path: `/blog/${params.slug}`,
      type: "article",
      publishedTime: loaderData?.date,
      modifiedTime: loaderData?.updated,
      section: loaderData?.category,
    }),
    scripts: loaderData
      ? [
          jsonLd({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: loaderData.title,
            description: loaderData.description,
            url: pageUrl(`/blog/${params.slug}`),
            datePublished: loaderData.date,
            ...(loaderData.updated ? { dateModified: loaderData.updated } : {}),
            author: { "@type": "Organization", name: "HostRight" },
            publisher: {
              "@type": "Organization",
              name: "HostRight",
              logo: {
                "@type": "ImageObject",
                url: "https://hostright.de/images/logo.svg",
              },
            },
            image: "https://hostright.de/images/og-default.svg",
          }),
          jsonLd(
            breadcrumbs([
              { name: "Home", path: "/" },
              { name: "Journal", path: "/blog" },
              { name: loaderData.title, path: `/blog/${params.slug}` },
            ]),
          ),
        ]
      : [],
  }),
  component: () => (
    <Shell>
      <MarkdownArticle item={Route.useLoaderData()} sidebar={false} />
    </Shell>
  ),
});
